import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetCnpjs", data.data);
  dispatch("ActionSetPagination", data.meta);
};

export const ActionFind = async (store, search) => {
  var cnpjs = {
    data: [],
    meta: {},
  };

  await services.cnpj.get_all(search).then((res) => {
    cnpjs = res.data;
  });
  return cnpjs;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.cnpj.show({ id: id }).then((res) => {
    dispatch("ActionSetCnpj", res.data.CNPJ);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.cnpj.store(payload).then((res) => {
    commit(types.SET_CNPJ, res.data.CNPJ);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.cnpj.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_CNPJ, res.data.CNPJ);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.cnpj.delete({ id: id }).then(() => {
    commit(types.SET_CNPJ, null);
  });
};

export const ActionSetCnpjs = ({ commit }, payload) => {
  commit(types.SET_CNPJS, payload);
};

export const ActionSetCnpj = ({ commit }, payload) => {
  commit(types.SET_CNPJ, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewCnpj = ({ commit }) => {
  commit(types.SET_CNPJ, {});
};

export const ActionToSelect = async ({ dispatch }, id) => {
  let response = [];
  await services.cnpj.to_select({ id: id }).then((res) => {
    response = res.data;
  });
  return response;
};
